<template>
  <Dialog ref="dialog" type="buy" :show="$bus.buy.show">
    <template v-slot:dialog-content>
      <div class="buy-list">
        <template v-for="(item, index) in $bus.selects">
          <Item class="item" :key="index" :imgSrc="item.thumb" :name="item.name">
            <template v-slot:mark>
              <div v-show="item.nums > 1" class="item-nums"><span>x</span><span>{{item.nums}}</span></div>
            </template>
          </Item>
        </template>
      </div>
      <div class="buy-info">
        <p class="buy-cost after">
          <i class="diamond"></i>
          <span class="gem-nums">{{$bus.price}}</span>
        </p>
        <p class="buy-cost before">
          <i class="diamond"></i>
          <span class="gem-nums">{{$bus.allPrice}}</span>
        </p>
      </div>
      <ff-button type="buy" @click.native="$bus.purchase">
        <span class="buy-btn-text">{{$bus.transify['T_P_PURCHASE']}}</span>
      </ff-button>
      <p class="buy-tip">{{$bus.hasToken ? $bus.transify['UNIQUE_BUY_ALREADY_HAVE_PART'] : $bus.transify['COMMON_TIPS_ITEM']}}</p>
    </template>
  </Dialog>
</template>

<script>
import Item from '@/components/common/Item'
import ffButton from '@/components/common/Button.vue'
import Dialog from '@/components/common/Dialog.vue'
export default {
  components: {
    Item,
    ffButton,
    Dialog
  },
  computed: {
    hasToken () {
      for (let item of this.$bus.selects) {
        if (item.isToken === 1) {
          return true
        }
      }
      return false
    }
  }
}
</script>

<style lang="scss" scoped>
.buy-list {
  @include flexrc;
  @include px2res(width, 712);
  margin: 0 auto;
  @include px2res(padding, 30, 0, 18);
  .item {
    @include px2res(margin, 0, 20);
    .item-nums {
      color: #FFDE00;
      font-weight: 500;
      position: absolute;
      z-index: 3;
      @include px2res(top, 12);
      @include px2res(right, 22);
      @include px2res(font-size, 30);
    }
  }
}
.buy-info {
  @include flexrc;
  @include px2res(width, 654);
  @include px2res(height, 57);
  background-color: rgba(0, 0, 0, .3);
  .buy-cost {
    @include flexrc;
    position: relative;
    line-height: 1.2;
    align-items: flex-end;
    @include px2res(font-size, 35);
    .diamond {
      @include px2res(width, 30);
      @include px2res(height, 26);
      @include px2res(margin-right, 8);
    }
    .gem-nums {
      @include px2res(height, 32);
    }
  }
  .buy-cost.after {
    color: #FFDE00;
    @include px2res(margin-right, 15);
  }
  .buy-cost.before {
    transform: scale(.8);
  }
  .buy-cost.before::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 106%;
    height: 1px;
    background: #FF0000;
  }
}
.buy-btn-text {
  flex: auto;
  @include px2res(height, 60);
  @include px2res(line-height, 66);
}
.buy-tip {
  color: #fff;
  opacity: .8;
  text-align: center;
  @include px2res(font-size, 20);
}
</style>



// WEBPACK FOOTER //
// src/components/buy/index.vue